import styled from 'styled-components'

import _ContentBlock from '~/components/content-block'

export const ContentBlock = styled(_ContentBlock)`
  text-align: left;
`
